import React from 'react';
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa"; // Importa os ícones
import logo from '../../assets/jacui-logo 1 (2).svg'; // Importa a logo

const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <div className="footer-content">
        {/* Seção Esquerda - Logo e Redes Sociais */}
        <div className="footer-content-left">
          <img src={logo} alt="Logo Vale do Jacui" />
          <div className="footer-social-icons">
            
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="social-icon" />
            </a>
            <a href="https://wa.me/5541998769002" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp className="social-icon" />
            </a>
          </div>
        </div>
        
        {/* Seção Central - Links */}
        <div className="footer-content-center">
     
          
        </div>
        
        {/* Seção Direita - Contato */}
        <div className="footer-content-right">
          <h2>Entre em contato</h2>
          <ul>
            <li>+55 (41) 99876-9002</li>
            <li>dfgadens@gmail.com</li>
            <li>Rod. BR 277 KM 120 - Rondinha - Campo Largo - PR </li>
          </ul>
        </div>
      </div>
      
      <hr />

      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} Vale do Jacui. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
